module.exports = __webpack_public_path__ + "r-v3/img/plus_white.0a939802.svg";